import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Search, Heart, Sparkles } from 'lucide-react';
const steps = [{
  icon: Search,
  title: 'Browse',
  chinese: '浏览',
  description: 'Explore our curated gallery of verified profiles and find your ideal companion.'
}, {
  icon: Heart,
  title: 'Meet',
  chinese: '相约',
  description: 'Arrange a meeting with ease. No deposit required, just genuine connection.'
}, {
  icon: Sparkles,
  title: 'Enjoy',
  chinese: '心动',
  description: 'Pay only when you are satisfied. Experience a memorable journey.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-[#0A0A0A] relative" data-id="element-99">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="text-center mb-20" data-id="element-101">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-102">
            How It Works
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-[#D4AF37] tracking-widest uppercase text-sm" data-id="element-103">
            Simple • Secure • Satisfying
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-104">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#333] to-transparent z-0" data-id="element-105" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-106">
              <div className="w-24 h-24 rounded-full bg-[#111] border border-[#333] flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(0,0,0,0.5)] group hover:border-[#D4AF37] transition-colors duration-300" data-id="element-107">
                <step.icon className="w-10 h-10 text-[#D4AF37] group-hover:scale-110 transition-transform duration-300" data-id="element-108" />
              </div>

              <h3 className="text-2xl font-serif text-white mb-2" data-id="element-109">
                {step.title}
              </h3>
              <p className="text-[#D4AF37] font-medium mb-4" data-id="element-110">{step.chinese}</p>
              <p className="text-gray-400 max-w-xs leading-relaxed" data-id="element-111">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}